
import axios from "axios";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication"

const TIMEOUT = 50000
const MAX_RETRIES = 2
const RETRY_DELAY = 1000

const api = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT as string,
  timeout: TIMEOUT
});

api.interceptors.request.use(async (config) => {
  try {
    const { user } = await FirebaseAuthentication.getCurrentUser()
    if (user) {
      const result = await FirebaseAuthentication.getIdToken({ forceRefresh: false })
      if (result?.token) {
        config.headers['Authorization'] = `Bearer ${result.token}`
      }
    }
  } catch {
    // No authenticated user — continue without Authorization header
  }
  // Ensure FormData is handled correctly - don't override Content-Type
  // Axios will automatically set multipart/form-data with boundary for FormData
  if (config.data instanceof FormData) {
    // Remove any manually set Content-Type to let axios set it with boundary
    delete config.headers['Content-Type']
  }
  return config;
});

api.interceptors.response.use(undefined, async (error) => {
  const config = error.config
  if (!config || config._retryCount >= MAX_RETRIES) return Promise.reject(error)

  // Retry on network errors and 5xx server errors
  const isNetworkError = error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED'
  const isServerError = error.response?.status >= 500
  if (!isNetworkError && !isServerError) return Promise.reject(error)

  config._retryCount = (config._retryCount || 0) + 1
  await new Promise(resolve => setTimeout(resolve, RETRY_DELAY * config._retryCount))
  return api.request(config)
});

export default api